import React from 'react';
import axios from 'axios';
import { Tab, Header, Segment, Form, Responsive } from 'semantic-ui-react';
import StudyPrograms from './StudyPrograms';
import ArchivedStudyPrograms from './ArchivedStudyPrograms';
import { fetchFaculties } from '../../Lookups/util';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class StudyProgramBasics extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            orgUnits: [],
            orgUnitId: localStorage.getItem('orgUnitId'),
            addNewSP: false,

            loaded: false,

        };
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        localStorage.removeItem('archived')
        axios.all([fetchFaculties()])
            .then(axios.spread((orgUnitsRes) => {
                this.setState({
                    orgUnits: orgUnitsRes.data.map(el => ({
                        key: el.id, value: el.id, text: el.name
                    }))
                });
            }))
            .catch(err => {
                console.log('Failed to fetch organizational units');
            });
        if (localStorage.getItem('orgUnitId')) { this.setState({ loaded: true }); }
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            loaded: false

        }, () => { this.setState({ [name]: value, loaded: !!value }); });

        localStorage.setItem('orgUnitId', value);
    }


    render() {
        const panes = [
            {
                menuItem: 'Aktivni smjerovi (studijski programi)',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <StudyPrograms
                        orgUnits={this.state.orgUnits}
                        addNewSP={this.state.addNewSP}
                    /></Tab.Pane>)
            },
            {
                menuItem: 'Arhivirani smjerovi (studijski programi)',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <ArchivedStudyPrograms />
                </Tab.Pane>)
            },
        ];

        return (
            <div>
                <Header as="h1">Osnovni studijski programi</Header>
                <Segment.Group raised>
                    <Segment raised>
                        <Header as="h3">
                            Odabir organizacione jedinice
                        </Header>
                    </Segment>
                    <Segment>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label>Organizaciona jedinica</label>
                                    <Form.Dropdown
                                        clearable
                                        placeholder="Odaberite organizacionu jedinicu"
                                        value={localStorage.getItem('orgUnitId') ? parseInt(localStorage.getItem('orgUnitId'), 10) : this.state.orgUnitId}
                                        onChange={this.handleInputChange}
                                        name="orgUnitId"
                                        options={this.state.orgUnits}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>
                                <Form.Field />
                                {/* <Form.Button color="blue" basic="true" label=" " onClick={() => this.setState({ loaded: true })}>Prikaži</Form.Button> */}
                            </Form.Group>
                        </Form>
                        <br />

                        {this.state.loaded &&
                        <Tab menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} />
                        }
                    </Segment>
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Admin/CreateStudyProgram/StudyProgramBasics.js